import { Link } from '@tanstack/react-router'

import { L, Note, P, Ul } from '@/features/guide/prose'

export function CreateRestaurantVi() {
  return (
    <>
      <P>
        Truy cập romi.io.vn và đăng nhập. Nếu chưa có tài khoản, hãy đăng ký trước: nhập số điện thoại hoặc email, ấn <L k="auth.sendCode" />, nhập mã nhận
        được (có hiệu lực 10 phút), đặt mật khẩu và ấn <L k="auth.createAccount" />.
      </P>
      <P>
        Ấn <L k="landing.createRestaurant" /> tại trang chủ, hoặc mở <L k="nav.myRestaurants" /> ở biểu tượng người dùng góc trên bên phải rồi ấn{' '}
        <L k="backOffice.create" />. Mỗi tài khoản tự tạo được một nhà hàng; muốn thêm, hãy liên hệ Romi.
      </P>
      <Ul>
        <li>
          <L k="restaurants.name" />: đặt theo thực tế tên nhà hàng.
        </li>
        <li>
          <L k="restaurants.slug" />: tự động tạo theo tên nhà hàng, có thể chỉnh sửa. Đây là địa chỉ web của nhà hàng, không được trùng với nhà hàng khác trên
          Romi (có báo trùng để đổi) và không thể đổi sau này.
        </li>
        <li>
          <L k="restaurants.color" />: màu cho giao diện nhà hàng.
        </li>
        <li>
          <L k="restaurants.mainLanguage" />: ngôn ngữ chính của nhà hàng. Mặc định là ngôn ngữ bạn đang dùng Romi.
        </li>
        <li>
          <L k="restaurants.secondaryLanguages" />: ngôn ngữ phụ mà nhà hàng muốn hỗ trợ (không bắt buộc).
        </li>
        <li>
          <L k="restaurants.branchName" />: mỗi nhà hàng cần ít nhất một chi nhánh. Đặt tên theo mong muốn (chính, main, 1, Quận 1, …).
        </li>
        <li>
          <L k="restaurants.branchSlug" />: tự động tạo theo tên chi nhánh, có thể chỉnh sửa. Là một phần địa chỉ web của chi nhánh và không trùng trong cùng
          nhà hàng.
        </li>
        <li>
          <L k="restaurants.timezone" />: múi giờ của chi nhánh, điền sẵn theo thiết bị. Gõ để tìm trong danh sách; mỗi múi giờ hiện kèm GMT.
        </li>
        <li>
          <L k="restaurants.currency" />: đơn vị tiền tệ dùng tại chi nhánh. Tự theo quốc gia của múi giờ (Asia/Ho_Chi_Minh ra VND) cho đến khi bạn tự chọn;
          gõ mã hoặc tên để tìm.
        </li>
      </Ul>
      <P>
        Ấn <L k="backOffice.create" /> và bạn đã có nhà hàng của riêng mình. Bạn được đưa tới trang <L k="nav.branches" />, và Romi được báo để hỗ trợ bạn
        thiết lập. Chỉ cần thêm hai bước <Link to="/app/guide/$guide" params={{ guide: 'setup-restaurant' }} className="text-accent-ink underline">cài đặt nhà hàng</Link> và{' '}
        <Link to="/app/guide/$guide" params={{ guide: 'setup-branch' }} className="text-accent-ink underline">cài đặt chi nhánh</Link> là bạn sẵn sàng vận hành.
      </P>
      <Note>
        Sẵn sàng bắt đầu? <Link to="/app/restaurants/new" className="underline">Tạo nhà hàng của bạn</Link>.
      </Note>
    </>
  )
}
